(function () {
  'use strict';

  var container = document.querySelector('[data-products-container]');
  if (!container || window.location.pathname.indexOf('/collections/') !== 0) {
    return;
  }

  var STORAGE_PREFIX = 'chatty-collection-position:';
  var MAX_AGE = 4 * 60 * 60 * 1000;
  var clickedProductPath = null;
  var clickedCardViewportTop = null;
  var restoreHandled = false;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function normalisedCollectionUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');

    var pairs = Array.from(url.searchParams.entries()).sort(function (a, b) {
      var first = a[0] + '=' + a[1];
      var second = b[0] + '=' + b[1];
      return first.localeCompare(second);
    });

    var params = new URLSearchParams();
    pairs.forEach(function (pair) {
      params.append(pair[0], pair[1]);
    });

    return url.pathname + (params.toString() ? '?' + params.toString() : '');
  }

  function storageKey() {
    return STORAGE_PREFIX + normalisedCollectionUrl();
  }

  function loadedPageCount() {
    return Array.from(container.children).filter(function (child) {
      return child.classList && child.classList.contains('row');
    }).length || 1;
  }

  function writeState() {
    var state = {
      url: normalisedCollectionUrl(),
      scrollY: window.scrollY || window.pageYOffset || 0,
      loadedPages: loadedPageCount(),
      productPath: clickedProductPath,
      productViewportTop: clickedCardViewportTop,
      savedAt: Date.now()
    };

    try {
      sessionStorage.setItem(storageKey(), JSON.stringify(state));
    } catch (error) {
      // Browser storage can be unavailable in strict privacy modes.
    }
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(storageKey());
      if (!raw) return null;

      var state = JSON.parse(raw);
      if (!state || state.url !== normalisedCollectionUrl()) return null;
      if (!state.savedAt || Date.now() - state.savedAt > MAX_AGE) {
        sessionStorage.removeItem(storageKey());
        return null;
      }
      return state;
    } catch (error) {
      return null;
    }
  }

  function pageUrl(pageNumber) {
    var url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    url.searchParams.set('page', String(pageNumber));
    return url.toString();
  }

  function removeCurrentPager() {
    container.querySelectorAll('[data-scroll], [data-load-more]').forEach(function (element) {
      element.remove();
    });
  }

  async function appendPage(pageNumber) {
    var response = await fetch(pageUrl(pageNumber), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) {
      throw new Error('Unable to restore collection page ' + pageNumber);
    }

    var documentFromResponse = new DOMParser().parseFromString(await response.text(), 'text/html');
    var incoming = documentFromResponse.querySelector('[data-products-container]');
    if (!incoming) return false;

    var appliedFilters = incoming.querySelector('.applied-filters');
    if (appliedFilters) appliedFilters.remove();

    removeCurrentPager();

    if (typeof colorSwatchesMediaChanged === 'function') {
      colorSwatchesMediaChanged(incoming);
    }

    var quickviewElements = Array.from(incoming.querySelectorAll('[data-quickview-action]'));
    while (incoming.firstChild) {
      container.appendChild(incoming.firstChild);
    }

    if (typeof initQuickView === 'function') {
      quickviewElements.forEach(function (element) {
        initQuickView(element);
      });
    }

    return true;
  }

  function findSavedProductCard(pathname) {
    if (!pathname) return null;

    var links = container.querySelectorAll('a[href*="/products/"]');
    for (var index = 0; index < links.length; index += 1) {
      try {
        if (new URL(links[index].href, window.location.origin).pathname === pathname) {
          return links[index].closest('.col-6') || links[index].closest('[class*="col-"]') || links[index];
        }
      } catch (error) {
        // Ignore malformed links and continue looking for the saved product.
      }
    }
    return null;
  }

  function restoreScroll(state) {
    var targetY = Number(state.scrollY) || 0;
    var card = findSavedProductCard(state.productPath);

    if (card && Number.isFinite(Number(state.productViewportTop))) {
      targetY = (window.scrollY || window.pageYOffset || 0) +
        card.getBoundingClientRect().top - Number(state.productViewportTop);
    }

    window.scrollTo(0, Math.max(0, targetY));
  }

  async function restoreIfNeeded(event) {
    if (restoreHandled) return;

    var navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var isBackForward = Boolean(event && event.persisted) || Boolean(navigation && navigation.type === 'back_forward');
    if (!isBackForward) return;

    var state = readState();
    if (!state) return;

    restoreHandled = true;
    var targetPages = Math.max(1, Number(state.loadedPages) || 1);
    var currentPages = loadedPageCount();

    try {
      for (var page = currentPages + 1; page <= targetPages; page += 1) {
        var appended = await appendPage(page);
        if (!appended) break;
      }

      if (typeof loadMoreCollection === 'function') loadMoreCollection();
      if (typeof productCardHoverInit === 'function') productCardHoverInit();
      if (window.animationStatus && window.AOS && typeof window.AOS.refreshHard === 'function') {
        window.AOS.refreshHard();
      }
    } catch (error) {
      // If a page cannot be rebuilt, still return as close as possible to the saved position.
    }

    requestAnimationFrame(function () {
      restoreScroll(state);
      setTimeout(function () {
        restoreScroll(state);
      }, 150);
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link || !container.contains(link)) return;

    try {
      clickedProductPath = new URL(link.href, window.location.origin).pathname;
    } catch (error) {
      clickedProductPath = null;
    }

    var card = link.closest('.col-6') || link.closest('[class*="col-"]');
    clickedCardViewportTop = card ? card.getBoundingClientRect().top : null;
    writeState();
  }, true);

  window.addEventListener('pagehide', writeState);
  window.addEventListener('pageshow', restoreIfNeeded);
})();
